/**
 * Generated by orval v7.3.0 🍺
 * Do not edit manually.
 * Tournated Dashboard API
 * Internal REST API consumed by the Tournated dashboard. Authenticated with a user JWT (Authorization: Bearer ...).
 * OpenAPI spec version: 1.0
 */

export type DashboardCreateLeagueMemberInputRolesItem =
  (typeof DashboardCreateLeagueMemberInputRolesItem)[keyof typeof DashboardCreateLeagueMemberInputRolesItem];

export const DashboardCreateLeagueMemberInputRolesItem = {
  organizer: "organizer",
  manager: "manager",
  referee: "referee",
} as const;
